import { JobsStage } from '~/layouts/jobs/components/JobsPanel/JobsPanel.model';
import { createSlice } from '../wrappers';

export interface IJobsSlice {
	activeStage: JobsStage;
}

const initialState = {
	activeStage: JobsStage.MAIN,
};

const jobsSlice = createSlice({
	name: 'jobs',
	initialState,
	reducers: {
		setActiveStage: (state, action) => {
			state.activeStage = action.payload;
		},
	},
});

export const { setActiveStage } = jobsSlice.actions;

export default jobsSlice.reducer;
